import { useTranslation } from "react-i18next";

import type { ActivityType } from "@lib/infrastructure";

// What the area suits, as one sentence
export const AreaActivityTypes = ({ activityTypes }: { activityTypes: ActivityType[] }) => {
  const { t } = useTranslation();

  if (activityTypes.length === 0) return null;

  return (
    <section className="flex flex-col gap-4">
      <h3 className="text-[20px] font-semibold leading-[25px]">{t("workplace:ActivityTypesFilterSectionTitle")}</h3>
      <p className="lowercase first-letter:uppercase">
        {activityTypes.map(activity => t("activityTypes:activityType", { context: activity })).join(", ")}
      </p>
    </section>
  );
};
